import Buscador from "../components/buscador/Buscador";
import Main from "../components/body/Main";

function Home() {
  return (
    <>    
        <Buscador />
        <Main />      
    </>
  );
}

export default Home;
